import utils from '../lib/utils';
import urls from '../lib/urls';
import tracking from '../lib/tracking';
import { default as partAlerts, populateAlternatives, buildAlertEditModal, getDistributors } from '../modules/part-alerts';
import ecad from '../modules/ecad-models';
import customSelect from '../modules/custom-select';
import global from '../modules/global';
import common from '../modules/common';
import lookup from '../modules/lookup';
import '../../vendor/jquery.popupoverlay';
import '../../vendor/jquery.shorten';
import '../../fragments/Dropdown';
import '../../fragments/Toggle';

common();
lookup();
partAlerts();
ecad();
customSelect();

export default function() {
    if (window.location.hash) {
        let $anchor = $(window.location.hash);
        if ($anchor.length) {
            let headerHeight = parseFloat($('.header').css('height'));
            let topPos = $anchor.offset().top - headerHeight;
            let stickyHeight = parseFloat($('.sticky-top-section').css('height'));
            topPos = $('.sticky-top-section').css('position') === 'fixed' ? topPos - stickyHeight - 5 : topPos - stickyHeight - 18;

            if (utils.checkScreenSize('<', 'tablet')) {
                topPos += 70;
            }

            $('html').animate({
                scrollTop: topPos
            }, 500);
        }
    }

    $(function() {
        if ($('lottie-player').length) {
            import('@lottiefiles/lottie-player');
        }
    });
    $(function() {
        global();
        tracking.init();

        $('.analytics-quick-jump-mobile').appendTo('header').removeClass('hide');

        const currentUrl = new URL(window.location);

        // remove SVGs and append info message for old IE
        (function() {
            let $content = $('.cad-models-content');
            let $img = $content.find('img');

            if (!$img.length || !$('html').hasClass('lt-ie9')) {
                return false;
            }

            $img.remove();
            $.each($content, function(_i, el) {
                let $el = $(el);

                $el.append('<div style="position: absolute; top: 49%; color: #E37235;">This version of Internet Explorer doesn\'t support SVG images.</div>');
            });
        })();

        if (window.FC.group.overviewCount >= 4) {
            $('head').append('<meta name="googlebot" content="index,follow">');
        }

        $('.analytics-overview a:not(.j-info-link)').on('click', function(e) {
            e.preventDefault();
            quickJump(this, 'Overview');
        });

        // pin price & stock function
        $('.pin-checkbox').on('change', function() {
            let $this = $(this);
            let $row = $this.closest('tr');
            let checked = $this.is(':checked');
            $row.attr('data-pinned', checked);
            applySortingOptions();
        });

        $('.all-pin-checkbox').on('change', applySortingOptions);

        $('.instock-checkbox').on('change', applySortingOptions);

        function applySortingOptions() {
            let $tableBody = $('.price-stock-table tbody');
            let checked = $('.instock-checkbox').is(':checked');
            let pinChecked = $('.all-pin-checkbox').is(':checked');
            $tableBody.find(pinChecked ? 'tr[data-pinned=false]' : 'tr').sort(function(a, b) {
                return parseInt($(a).attr('data-order')) - parseInt($(b).attr('data-order'));
            }).appendTo($tableBody);
            if (checked) {
                $tableBody.find(pinChecked ? 'tr[data-pinned=false]' : 'tr').sort(function(a, b) {
                    let stockA = parseInt($(a).attr('data-stock'));
                    let stockB = parseInt($(b).attr('data-stock'));
                    if (stockA != 0 && stockB == 0) return -1;
                    if (stockA == 0 && stockB != 0) return 1;
                    return 0;
                }).appendTo($tableBody);
            }
            if ($('.price-stock-expandable').attr('data-state') == 'collapsed') {
                $('.price-stock-table .price-stock-tr').removeClass('hide');
                $('.price-stock-table .price-stock-tr:nth-child(n+11)').addClass('hide'); // exclude first 10
            }
        }

        $('.price-stock-expandable').on('click', function() {
            let $this = $(this);
            let state = $this.attr('data-state');
            if (state === 'collapsed') {
                $this.attr('data-state', 'expanded');
                $this.text('View Less');
                $('.price-stock-table .price-stock-tr').removeClass('hide');
            } else {
                $this.attr('data-state', 'collapsed');
                $this.text('View All');
                $('.price-stock-table .price-stock-tr:nth-child(n+11)').addClass('hide'); // exclude first 10
                $('html, body').animate({
                    scrollTop: $('#priceStockHeader').offset().top - $('.sticky-top-section').outerHeight() - $('.header').outerHeight()
                }, 500);
            }
        });

        function initPagination($paginationHolder) {

            let type = $paginationHolder.data('type') || 'list',
                parentTag,
                childTag;

            if(type === 'list') {
                parentTag = 'ul';
                childTag = 'li';
            } else {
                parentTag = 'tbody';
                childTag = 'tr';
            }

            let length = $paginationHolder.data('length'),
                step = Number($paginationHolder.data('step')),
                size = Math.ceil(length / step),
                page = 1,
                from = 1,
                to = step,
                $list = $paginationHolder.find(parentTag),
                $left = $paginationHolder.find('.j-pagination-left'),
                $right = $paginationHolder.find('.j-pagination-right'),
                $from = $paginationHolder.find('.j-pagination-from'),
                $to = $paginationHolder.find('.j-pagination-to'),
                $total = $paginationHolder.find('.j-pagination-total');

            $left.on('click', function () {
                if (page === 1) {
                    return false;
                }
                page -= 1;
                update();
            });

            $right.on('click', function () {
                if (page === size) {
                    return false;
                }
                page += 1;
                update();
            });

            function update() {

                from = (page - 1) * step + 1;
                to = Math.min(page * step, length);

                if (page === 1) {
                    $left.addClass('disabled');
                } else {
                    $left.removeClass('disabled');
                }

                if (page === size) {
                    $right.addClass('disabled');
                } else {
                    $right.removeClass('disabled');
                }

                $list.find(childTag).each(function (index, li) {
                    if ((index + 1) >= from && index < to) {
                        $(li).show();
                    } else {
                        $(li).hide();
                    }
                });

                $from.text(from);
                $to.text(to);
            }

            $paginationHolder.data('reset', function(newLength) {

                length = newLength;
                size = Math.ceil(length / step);
                page = 1;
                from = 1;
                to = step;

                $paginationHolder.data('length', length);
                $total.text(length);

                page = 1;
                update();
            });
        }

        $('.j-pagination-holder').each(function (_i, pagination) {
            initPagination($(pagination));
        });

        // change manufacturer
        $('.j-select-manufacturer').on('change', function () {
            window.location = $(this).val();
        });

        $('.j-fff-tab').on('click', function () {
            $('.j-fff-content').show();
            $('.j-eq-tab').removeClass('active');
            $('.j-eq-content').hide();
            $(this).addClass('active');
        });

        $('.j-eq-tab').on('click', function () {
            $('.j-eq-content').show();
            $('.j-fff-tab').removeClass('active');
            $('.j-fff-content').hide();
            $(this).addClass('active');
        });


        $('.j-select-manufacturer').customSelectOverlay();
        $('.j-select-manufacturer-temp').remove();
        $('.j-select-manufacturer').removeClass('hide');
        $('.select-manufacturer .select-holder').show();

        $('.j-copy-url').on('click', function () {
            let $this = $(this);
            let $copyElement = $(this).find('span');
            navigator.clipboard.writeText(window.location.href);
            $copyElement.text(utils.translate('copied.exclamation'));
            $this.addClass('buy-button');
            setTimeout( function() {
                $copyElement.text(utils.translate('copy.link'));
                $this.removeClass('buy-button');
            }, 1000);
        });

        utils.createModal($('#j-share-email-modal'), $('.j-email'), {
            beforeopen: function() {
                if (currentUrl.searchParams.has('compare')) {
                    let compareVariables = currentUrl.searchParams.get('compare').split('--');
                    let compareObj = {
                        part: compareVariables[0],
                        mfr: utils.convertDashFormat(compareVariables[1])
                    };
                    //Fill in compare part of email for Sharing by Email
                    $('span.compareView').show();
                    $('span.comparePartNumberView').text(compareObj.part);
                    $('span.compareManufacturerView').text(compareObj.mfr);
                    $('input[name=comparePartNumber]').val(compareObj.part);
                    $('input[name=compareManufacturer]').val(compareObj.mfr);
                } else {
                    $('span.compareView').hide();
                    $('span.comparePartNumberView').text('');
                    $('span.compareManufacturerView').text('');
                    $('input[name=comparePartNumber]').val('');
                    $('input[name=compareManufacturer]').val('');
                }
                
                $('.j-send-email').removeClass('disabled');
                $('.j-send-email').prop('disabled', false);
                $('input.email-to').parents('fieldset').removeClass('error');
                $('.email-to').val('');
                $('.recipient-extra').addClass('hide');
                $('.add-recipient').removeClass('hide');
                $('#j-share-email-modal').find('.alert-success').hide();
                $('#j-share-email-modal').find('.alert-danger').hide();

                //Add URL to email and set new email body for Sharing by Email
                $('span.pageUrlView').text(window.location.href);
            }
        });

        $('.j-send-email').on('click', function (e) {
            e.preventDefault();
            let $form = $(this).closest('form');
            if (checkEmail()) {
                $('#j-share-email-modal').find('.loading').css('display', 'block');
                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    data: $form.serialize()
                }).done(function(data) {
                    $('#j-share-email-modal').find('.alert-success').show();
                    $('.j-send-email').prop('disabled', true);
                    $('.j-send-email').addClass('disabled');
                    $('.email-to').val('');
                    setTimeout(function(){
                        $('.j-send-email').prop('disabled', false);
                        $('.j-send-email').removeClass('disabled');
                    }, 3000);
                }).fail(function() {
                    $('#j-share-email-modal').find('.j-err').show();
                }).always(function() {
                    $('#j-share-email-modal').find('.loading').css('display', 'none');
                });
            }
        });

        $('.add-recipient').on('click', function() {
            let $this = $(this);
            let extraRecipient = $this.parent().find('.recipient-extra.hide');
            if (extraRecipient.length) {
                extraRecipient.first().removeClass('hide');
                if (extraRecipient.length == 1) {
                    $this.addClass('hide');
                }
            }
        });

        $('.recipient-extra i').on('click', function() {
            let $this = $(this);
            $(this).parent().find('input').val('');
            $(this).parent().addClass('hide');
            let addButton = $('.add-recipient');
            if (addButton.hasClass('hide')) {
                addButton.removeClass('hide');
            }
        });

        $('.j-print').on('click', function () {
            window.print();
        });

        $('.j-datasheet-change').on('click', function(e) {
            e.preventDefault();
            $('.j-datasheet-input').trigger('focus');
        });

        $('.j-datasheet-input').on('focus', function() {
            $('.j-datasheet-change').hide();
        }).on('blur', function() {
            $('.j-datasheet-change').show();
        });

        $('.anchor').removeClass('is-disabled');
        $('.analytics-quick-jump .anchor, .analytics-quick-jump-mobile .anchor').on('click', function(e) {
            e.preventDefault();
            if ($(this).hasClass('is-disabled')) {
                return;
            }
            if (!$('.quick-jump-items').hasClass('hide')) {
                $('.quick-jump-btn').trigger('click');
            }
            quickJump(this, 'QuickJump');
        });

        $('.quick-jump-btn').on('click', function() {
            if ($('.quick-jump-items').hasClass('hide')) {
                $('.quick-jump-items').removeClass('hide');
                $(this).find('span').removeClass('arrow-bottom').addClass('arrow-top');
            } else {
                $('.quick-jump-items').addClass('hide');
                $(this).find('span').removeClass('arrow-top').addClass('arrow-bottom');
            }
        });

        let $stickyTopSection = $('.sticky-top-section');
        let $background = $stickyTopSection.find('.mask-background');
        let stickyHeight = $stickyTopSection.offset().top + parseFloat($stickyTopSection.css('height'));
        let $dummy = $('<div></div>');
        $dummy.css({
            'max-width': $stickyTopSection.css('max-width'),
            width: $stickyTopSection.css('width'),
            height: $stickyTopSection.outerHeight(),
            display: 'none'
        });
        $dummy.insertAfter($stickyTopSection);
        let statsOffset = $stickyTopSection.offset().top;
        let topPosition = parseFloat($('.header').outerHeight());
        let displayType = $stickyTopSection.css('display');
        let disableSticky = function() {
            $background.css({
                display: 'none'
            });
            $dummy.css({
                display: 'none'
            });
            $stickyTopSection.css({
                position: 'relative',
                top: 'auto',
                left: 'auto',
                'border-bottom': 'none',
                width: 'auto',
                padding: '10px 0 0 0'
            });
        };
        let enableSticky = function() {
            $dummy.css({
                display: displayType
            });
            $background.css({
                display: 'block',
                height: $stickyTopSection.innerHeight(),
                width: $stickyTopSection.outerWidth() + 60,
                left: -30,
            });
            $stickyTopSection.css({
                position: 'fixed',
                top: topPosition,
                left: parseFloat($('#page').offset().left),
                'border-bottom': '1px solid #D4D4D4',
                width: parseFloat($('#page').outerWidth()),
                padding: utils.checkScreenSize('>=', 'tablet') ? '10px 0 12px 0' : '10px 10px 12px 10px'
            });
        };
        let onScroll = function() {
            let gapSum = statsOffset - topPosition;
            if ($(document).scrollTop() >= gapSum) {
                enableSticky();
            } else {
                disableSticky();
            }
            let pos = $(document).scrollTop();
            $($('.analytics-quick-jump li:not(.hide) .anchor').get().reverse()).each(function() {
                let $this = $(this);
                $('.quick-jump-highlight').removeClass('quick-jump-highlight');
                if (pos + stickyHeight > $($this.attr('href')).offset().top - 10) {
                    $this.addClass('quick-jump-highlight');
                    return false;
                }
            });
        };

        $(window).on('scroll', onScroll);
        $(document).scrollTop();
        $(window).on('resize', function() {
            topPosition = parseFloat($('.header').outerHeight());
            statsOffset = parseFloat($('.top-section').offset().top) + parseFloat($('.top-section').css('padding-top')) + parseFloat($('.breadcrumbs').outerHeight()) + 2;
            $dummy.css({
                height: $stickyTopSection.outerHeight() - parseFloat($stickyTopSection.css('padding-bottom')) - 1
            });
            onScroll();
        });
        
        let $partAlertModal = $('.part-alerts-modal');
        if (window.FC.group.equivalents.length) {
            populateAlternatives(window.FC.group.equivalents);
        }
        if (window.FC.group.alert) {
            $partAlertModal.find('.update-alert').removeClass('hide');
            $partAlertModal.find('.insert-alert').addClass('hide');
            $partAlertModal.find('.j-pricing-alert-expire-select').prepend($('<option>', {
                value: 0,
                text: 'now'
            }));
            $partAlertModal.find('.j-pricing-alert-expire-select option[value=0]').prop('selected', true);
            buildAlertEditModal($partAlertModal, {
                settings: window.FC.group.alert.settings
            });
        } else {
            buildAlertEditModal($partAlertModal, {
                default: true
            });
            if ($partAlertModal.find('.j-alert-limit-error').length) {
                $partAlertModal.find('.j-alert-limit-error').removeClass('hide');
                $partAlertModal.find('.j-alerts-next').addClass('disabled');
                $partAlertModal.find('.j-alerts-next').prop('disabled', true);
            }
        }

        let initDistributors = false;
        $('.j-alert').on('click', function() {
            if (!initDistributors) {
                getDistributors();
                initDistributors = true;
            }
            
            $('#partAlertModal').popup('show');
            setTimeout(function() {
                $($('#partAlertModal .j-alert-settings input[type!=hidden]')[0]).trigger('focus'); // focus on first non-hidden input
            }, 500);
        });
        let $partCompareModal = $('.part-compare-modal');
        let $partCompareModalLoading = $partCompareModal.find('.loading');
        let $partCompareModalTemplateRow = $partCompareModal.find('.template-row');
        let $partCompareModalEmptyRow = $partCompareModal.find('.empty-row');
        let $partCompareModalErrorRow = $partCompareModal.find('.error-row');
        let $partCompareModalPagination = $partCompareModal.find('.pagination');
        let $paginationButton = $('<button class="basic-button"></button>');
        let $partSelectedWrapper = $partCompareModal.find('.selected-wrapper');
        let $partSelectedTagHolder = $partSelectedWrapper.find('.tag-holder');
        let $partSelectedTemplate = $partSelectedTagHolder.find('.tag.template');
        function loadPartCompareModal(partNumber, page) {
            $partCompareModalErrorRow.addClass('hide');
            $partCompareModalEmptyRow.addClass('hide');
            $partCompareModalLoading.css('display', 'block');
            $('.part-compare-modal .j-compare-check').prop('disabled', false);
            $('.part-compare-modal .j-success-button').addClass('disabled');
            $('.part-compare-modal .search-bar').removeClass('input-error');
            if (partNumber.length < 3) {
                $partCompareModal.find('tbody tr:not(.template-row):not(.empty-row):not(.error-row)').remove();
                $partCompareModal.find('tbody tr:not(.template-row)').addClass('hide');
                $partCompareModalErrorRow.find('.alert').text(window.FC.translate['searchbox.instructions']);
                $partCompareModalErrorRow.removeClass('hide');
                $partCompareModalLoading.css('display', 'none');
                $partCompareModalPagination.closest('tfoot').addClass('hide');
                return;
            }
            $.ajax({
                url: '/parametric/searchApi',
                method: 'GET',
                data: {
                    partNumber: partNumber,
                    page: page
                },
                success: function (data) {
                    $partCompareModal.find('tbody tr:not(.template-row):not(.empty-row):not(.error-row)').remove();
                    if (!data.data.length) {
                        $partCompareModalEmptyRow.removeClass('hide');
                    } else {
                        $partCompareModalEmptyRow.addClass('hide');
                    }

                    $.each(data.data, function(_index, item) {
                        let $clone = $partCompareModalTemplateRow.clone();
                        $clone.attr('data-part-number', item['Manufacturer Part Number']);
                        $clone.attr('data-manuf', item['Manufacturer']);
                        $clone.attr('data-desc', item['Description']);
                        $clone.attr('data-mfrid', item['mfrid']);
                        if ($partSelectedTagHolder.find('.tag:not(.template)[data-part-number="' + item['Manufacturer Part Number'] + '"][data-manuf="' + item['Manufacturer'] + '"]').length) {
                            $clone.find('.j-compare-check').prop('checked', true);
                        }
                        $clone.find('.part-number-cell').text(item['Manufacturer Part Number']);
                        $clone.find('.manuf-cell').text(item['Manufacturer']);
                        $clone.find('.desc-cell').html(item['Description']);
                        $clone.removeClass('template-row');
                        $partCompareModal.find('.parametric-compare-table tbody').append($clone);
                    });
                    postSelectPartUpdate();

                    // pagination
                    let pagination = data.pagination;
                    $partCompareModalPagination.find('button').remove();
                    if (!pagination || pagination.totalPages == 0) {
                        $partCompareModalPagination.closest('tfoot').addClass('hide');
                        return;
                    } else {
                        $partCompareModalPagination.closest('tfoot').removeClass('hide');
                    }
                    let displayedAmount = Math.min(5, pagination.totalPages);
                    let startPage = pagination.currentPage - Math.floor(displayedAmount/2);
                    startPage = startPage > 0 ? startPage : 1;

                    let endPage = startPage + displayedAmount;
                    let overflow = endPage - pagination.totalPages;
                    if (overflow > 0) {
                        startPage = startPage - overflow + 1;
                        startPage = startPage > 0 ? startPage : 1;
                    }

                    if (startPage > 1) {
                        let $prev = $paginationButton.clone();
                        $prev.text('Prev');
                        $prev.attr('data-term', data.params.term);
                        $prev.attr('data-page', pagination.currentPage-1);
                        $partCompareModalPagination.append($prev);
                    }
                    let count = 0;
                    let currentPage = startPage;
                    while (count < displayedAmount) {
                        currentPage = startPage + count;
                        if (currentPage > pagination.totalPages) {
                            break;
                        }
                        let $clone = $paginationButton.clone();
                        $clone.text(currentPage);
                        if (currentPage == pagination.currentPage) {
                            $clone.addClass('current');
                        }
                        $clone.attr('data-term', data.params.term);
                        $clone.attr('data-page', currentPage);
                        $partCompareModalPagination.append($clone);
                        count++;
                    }
                    if (currentPage < pagination.totalPages) {
                        let $next = $paginationButton.clone();
                        $next.text('Next');
                        $next.attr('data-term', data.params.term);
                        $next.attr('data-page', pagination.currentPage+1);
                        $partCompareModalPagination.append($next);
                    }
                },
                error: function (err) {
                    $partCompareModal.find('tbody tr:not(.template-row):not(.empty-row):not(.error-row)').remove();
                    $partCompareModal.find('tbody tr:not(.template-row)').addClass('hide');
                    try {
                        $partCompareModalErrorRow.find('.alert').text(err.responseJSON.message);
                    } catch (parseErr) {
                        $partCompareModalErrorRow.find('.alert').text('Something went wrong!');
                    }
                    $partCompareModalErrorRow.removeClass('hide');
                    $partCompareModalPagination.closest('tfoot').addClass('hide');
                }
            }).always(function() {
                $partCompareModalLoading.css('display', 'none');
            });
        }
        utils.createModal($('.part-compare-modal'), $('.compare-button'), {
            blur: false,
            scrolllock: true,
            onopen: function() {
                loadPartCompareModal($partCompareModal.attr('data-part-number'), 1);
            }
        });

        $(document).on('click', '.part-compare-modal .pagination button', function() {
            let $this = $(this);
            loadPartCompareModal($this.attr('data-term'), $this.attr('data-page'));
        });

        $(document).on('change', '.part-compare-modal .j-compare-check', function() {
            let $this = $(this);
            let $row = $this.closest('tr');
            if ($this.is(':checked')) {
                let $clone = $partSelectedTemplate.clone();
                $clone.attr('data-part-number', $row.attr('data-part-number'));
                $clone.attr('data-manuf', $row.attr('data-manuf'));
                $clone.attr('data-mfrid', $row.attr('data-mfrid'));
                $clone.attr('data-desc', $row.attr('data-desc'));
                $clone.find('.text').text($row.attr('data-part-number') + ' - ' + $row.attr('data-manuf'));
                $clone.removeClass('template');
                $partSelectedTagHolder.append($clone);
            } else {
                $partSelectedTagHolder.find('.tag:not(.template)[data-part-number="' + $row.attr('data-part-number') + '"][data-manuf="' + $row.attr('data-manuf') + '"]').remove();
            }
            postSelectPartUpdate();
        });

        $partSelectedWrapper.on('click', '.j-close', function() {
            let $this = $(this).closest('.tag');
            $partCompareModal.find('.parametric-compare-table tbody tr[data-part-number="' + $this.attr('data-part-number') + '"][data-manuf="' + $this.attr('data-manuf') + '"] .j-compare-check').trigger('click');
            $this.remove();
            postSelectPartUpdate();
        });

        $('.part-compare-modal .j-success-button').on('click', function() {
            let $this = $(this);
            if ($this.hasClass('disabled')) {
                return;
            }
            let $selected  = $partSelectedTagHolder.find('.tag:not(.template)');
            if ($this.hasClass('pdp-compare')) {
                let $firstSelected = $($selected[0]);
                let obj = {
                    part: $firstSelected.attr('data-part-number'),
                    mfrid: $firstSelected.attr('data-mfrid'),
                    mfr: $firstSelected.attr('data-manuf'),
                    desc: $firstSelected.attr('data-desc')
                };
                let $partTitle = $('.part-title-compare');
                let $partTitleName = $partTitle.find('a');
                let $partTitleManuf = $partTitle.find('.part-manu');
                let $partTitleDesc = $partTitle.find('.part-desc');
                $partTitleName.prop('href', `/detail/${encodeURIComponent(obj.part)}/${encodeURIComponent(utils.convertWhitespaceFormat(obj.mfr))}`);
                $partTitleName.text(obj.part);
                $partTitleManuf.text(obj.mfr);
                $partTitleDesc.text(obj.desc);
                $partTitle.attr('data-value', JSON.stringify(obj));
                $('.part-compare-modal').popup('hide');
                $('.part-title-compare').removeClass('hide');
                return;
            }
            if (!$selected.length) {
                return;
            }
            let compare = [{
                part: $partCompareModal.attr('data-part-number'),
                manufacturer: $partCompareModal.attr('data-manuf')
            }];
            $selected.each(function(_index, item) {
                let $item = $(item);
                compare.push({
                    part: $item.attr('data-part-number'),
                    manufacturer: $item.attr('data-manuf')
                });
            });
            location.href = urls.compare(compare);
        });

        $('.part-compare-modal .search-bar').on('keypress', function(e) {
            if(e.which == 13) { // enter
                $('.part-compare-modal .j-find-button').trigger('click');
            }
        });

        $('.part-compare-modal .j-find-button').on('click', function() {
            let $this = $(this);
            let $input = $this.closest('.search-bar-holder').find('.search-bar');
            let value = $input.val();
            if (value) {
                loadPartCompareModal(value, 1);
            } else {
                loadPartCompareModal($partCompareModal.attr('data-part-number'), 1);
            }
        });

        function postSelectPartUpdate() {
            let $all = $('.part-compare-modal tr:not(.template-row) .j-compare-check:not(:checked)');
            let $selected = $partSelectedTagHolder.find('.tag:not(.template)');
            if ($selected.length) {
                $partSelectedWrapper.removeClass('hide');
                $('.part-compare-modal .j-success-button').removeClass('disabled');
            } else {
                $partSelectedWrapper.addClass('hide');
                $('.part-compare-modal .j-success-button').addClass('disabled');
            }
            if ($('.part-compare-modal').attr('data-select-multiple') == 'false') {
                if ($selected.length >= 1) {
                    $all.prop('disabled', true);
                } else {
                    $all.prop('disabled', false);
                }
            }
        }

        $('.compare-table .close-button').on('click', function() {
            let $headerCell = $('.compare-table .compare-part-cell');
            $headerCell.find('.compare-datasheet-button').remove();
            $('.compare-table .data-row.new-row:not(.template-row)').remove();
            $headerCell.css('display', 'none');
            $('.compare-table .select-th').css('display', 'table-cell');
            $('.compare-table .data-row').removeClass('diff-row').removeClass('j-same-row');
            $('.compare-diff-switch').prop('disabled', true);
            $('.compare-diff-switch').closest('.diff-switch-wrapper').addClass('disabled');
            compareColDisplayAdjustment();
            diffSwitchCheck();
            $('.compare-table').removeClass('comparing-part');
            $('.j-compare-select').val('').trigger('change');
            currentUrl.searchParams.delete('compare');
            window.history.pushState({}, '', currentUrl);
        });

        $('.j-compare-select').on('change', function() {
            let $this = $(this);
            let selectVal = $this.val();
            if (!selectVal) {
                $('.compare-button').addClass('hide');
                $('.part-title-compare').addClass('hide');
                return;
            }
            if (selectVal == 'lookup') {
                $('.compare-button').removeClass('hide');
                $('.part-title-compare').addClass('hide');
                return;
            }
            $('.compare-button').addClass('hide');
            let obj = JSON.parse(selectVal);
            let $partTitle = $('.part-title-compare');
            let $partTitleName = $partTitle.find('a');
            let $partTitleManuf = $partTitle.find('.part-manu');
            let $partTitleDesc = $partTitle.find('.part-desc');
            $partTitleName.prop('href', `/detail/${encodeURIComponent(obj.part)}/${encodeURIComponent(utils.convertWhitespaceFormat(obj.mfr))}`);
            $partTitleName.text(obj.part);
            $partTitleManuf.text(obj.mfr);
            $partTitleDesc.text(obj.desc);
            $partTitle.attr('data-value', selectVal);
            $partTitle.removeClass('hide');
        });

        $('.compare-submit-btn').on('click', function() {
            let $btn = $(this);
            let $this = $('.j-compare-select');
            let selectVal = $this.val();
            let $partTitle = $('.part-title-compare');
            if (!selectVal) {
                $this.closest('.select-holder').addClass('is-error');
                return;
            } else if (selectVal == 'lookup' && $partTitle.hasClass('hide')) {
                $this.closest('.select-holder').removeClass('is-error');
                $('.compare-button').trigger('click');
                return;
            }
            $this.closest('.select-holder').removeClass('is-error');
            let obj = JSON.parse($partTitle.attr('data-value'));
            triggerCompare(obj);
        });

        function triggerCompare(compareObj) {
            let $btn = $('.compare-submit-btn');
            let $templateRow = $('.compare-table .data-row.template-row');
            $btn.find('.loading').css('display', 'block');
            $.ajax({
                url: '/compareApi',
                method: 'GET',
                data: compareObj,
                success: function (data) {
                    currentUrl.searchParams.set('compare', `${data.mpn}--${utils.convertWhitespaceFormat(data.manuf)}`);
                    window.history.pushState({}, '', currentUrl);

                    $('.compare-table').addClass('comparing-part');
                    let result = data.data;
                    $('.compare-table .data-row.new-row:not(.template-row)').remove();
                    for(let item of result) {
                        let field = item.field;
                        let val = item.value;
                        let $row = $(`.compare-table .data-row[data-field='${field}']`);
                        if (!$row.length) {
                            $row = $templateRow.clone();
                            $row.attr('data-field', field);
                            $row.find('.field-cell').text(field);
                            $row.removeClass('template-row');
                            $('.compare-table tbody').append($row);
                        }

                        $row.attr('data-compare-empty', val == '');
                        let $compareCol = $row.find('.compare-part-cell');
                        $compareCol.attr('data-value', val);
                        let htmlContent = '';
                        if (field === 'Pbfree Code') {
                            htmlContent += `<i class="icon-pbfree ${val === 'Yes' ? 'yes' : 'no'}"></i>`;
                        } else if (field === 'Rohs Code') {
                            htmlContent += `<i class="icon-rohs ${val === 'Yes' ? 'yes' : 'no'}"></i>`;
                        }
                        htmlContent += val;
                        $compareCol.html(htmlContent);
                    }
                    $('.compare-table .data-row:not(.template-row)').each(function(index, item) {
                        let $item = $(item);
                        if (!$item.has('.compare-part-cell').length) {
                            $item.append('<td class="compare-part-cell" data-value=""></td>');
                        }
                        let diff = $item.find('.main-part-cell').attr('data-value').trim() != $item.find('.compare-part-cell').attr('data-value').trim();
                        $item.removeClass('diff-row').removeClass('j-same-row');
                        $item.addClass(diff ? 'diff-row' : 'j-same-row');
                    });
                    let $diffSwitch = $('.compare-diff-switch');
                    $diffSwitch.prop('disabled', false);
                    $diffSwitch.closest('.diff-switch-wrapper').removeClass('disabled');
                    diffSwitchCheck();

                    // header
                    let $headerCell = $('.compare-table .info-th.compare-part-cell');
                    let $partTitleIcon = $headerCell.find('.part-title i');
                    let $partTitleName = $headerCell.find('.part-title a');
                    let $partTitleManuf = $headerCell.find('.part-title .part-manu');
                    let $buyButton = $headerCell.find('.buy-button');
                    $partTitleIcon.addClass('icon-' + utils.toClassName(data.class));
                    $partTitleName.text(data.mpn);
                    $partTitleName.prop('href', `/detail/${encodeURIComponent(data.mpn)}/${encodeURIComponent(utils.convertWhitespaceFormat(compareObj.mfr))}`);
                    $partTitleManuf.text(data.manuf);
                    $buyButton.prop('href', `/search/${encodeURIComponent(data.mpn)}?manufacturer=${encodeURIComponent(data.manuf)}`);
                    if (data.datasheet) {
                        $headerCell.append($(`<a class="track basic-button compare-datasheet-button" href="${data.datasheet}" data-gaaction="mfgdatasheet" data-category="list" data-url="${data.impression}" data-title="Datasheet" target="_blank"><i class="list-pdf-icon"></i> Datasheet</a>`));
                    } else {
                        $headerCell.find('.compare-datasheet-button').remove();
                    }
                    $headerCell.css('display', 'table-cell');
                    $('.compare-table .select-th').css('display', 'none');
                    compareColDisplayAdjustment();
                },
                error: function () {
                },
                complete: function() {
                    $btn.find('.loading').css('display', 'none');
                }
            });
        }

        $('.compare-diff-switch').on('change', diffSwitchCheck);
        function diffSwitchCheck() {
            let $diffSwitch = $('.compare-diff-switch');
            $('.compare-table .data-row:not(.template-row)').removeClass('hide');
            if ($diffSwitch.prop('disabled')) {
                $diffSwitch.prop('checked', false);
            }
            if ($diffSwitch.is(':checked')) {
                $('.compare-table .data-row:not(.template-row).j-same-row').addClass('hide');
                $('.compare-table .data-row:not(.template-row).diff-row').removeClass('hide');
            }
        }

        function compareColDisplayAdjustment() {
            if (!$('.compare-table').length) {
                return;
            }
            let display = $('.compare-table .info-th.compare-part-cell').css('display');
            let selectDisplay = $('.compare-table .select-th').css('display');
            if (utils.checkScreenSize('>=', 'tablet')) {
                $('.compare-table .main-part-cell').css('display', 'table-cell');
                $('.compare-table .main-part-cell').css('width', '40%');
                $('.compare-table .compare-part-cell').css('width', '40%');
                if (display != 'none') {
                    $('.compare-table .compare-part-cell').css('display', 'table-cell');
                }
                if (selectDisplay != 'none') {
                    $('.compare-table .select-th').css('display', 'table-cell');
                    $('.compare-table .select-th').css('width', '250px');
                }
            } else { // mobile
                $('.compare-table .main-part-cell').css('display', 'inline-block');
                $('.compare-table .main-part-cell').css('width', '49%');
                $('.compare-table .compare-part-cell').css('width', '49%');
                if (display != 'none') {
                    $('.compare-table .compare-part-cell').css('display', 'inline-block');
                }
                if (selectDisplay != 'none') {
                    $('.compare-table .select-th').css('display', 'inline-block');
                    $('.compare-table .select-th').css('width', '49%');
                }
            }
        }

        $(window).on('resize', function () {
            compareColDisplayAdjustment();
        });

        if (currentUrl.searchParams.has('compare')) {
            const compareParam = currentUrl.searchParams.get('compare');
            const separatorIndex = compareParam.indexOf('--');
            const compareObj = {
                part: compareParam.substring(0, separatorIndex),
                mfr: utils.convertDashFormat(compareParam.substring(separatorIndex + 2))
            };

            triggerCompare(compareObj);
        }

        $('.show-price-breaks').on('click', function() {
            let $this = $(this);
            $this.siblings('.j-price-breaks').removeClass('hide');
            $this.remove();
        });

        $('.expand-details').on('click', function() {
            let $this = $(this);
            let $row = $this.parents('.price-stock-tr');
            if ($this.find('.arrow-right').length) {
                $row.find('.td-price-range').addClass('hide');
                $row.find('.td-desc').addClass('visible');
                $row.find('.td-price').addClass('visible');
                $this.find('.arrow-right').addClass('arrow-bottom').removeClass('arrow-right');
            } else {
                $row.find('.td-price-range').removeClass('hide');
                $row.find('.td-desc').removeClass('visible');
                $row.find('.td-price').removeClass('visible');
                $this.find('.arrow-bottom').addClass('arrow-right').removeClass('arrow-bottom');
            }
        });

        if ($('.ai-summary').length) {
            let rawInput = $('.ai-summary').attr('data-input');
            $.ajax({
                url: '/api/pdpSummary',
                type: 'POST',
                data: {
                    data: rawInput
                },
                success: function (data) {
                    $('.ai-summary').find('p').html(data.response);
                }
            }).always(function() {
                $('.ai-summary').find('.loading').css('display', 'none');
            });
        }

        $('.j-question').on('click', function() {
            $(this).siblings('p').toggle();
        });

        $('.td-price .hyperlink').one('click', priceSeeMore);
        $('.price-stock-section .td-description').shorten();
    });

    /**
     * For quick jump navigation
     * @param anchor
     */
    function quickJump(element, event) {
        let $element = $(element);

        let type = $element.attr('data-type');
        tracking.ckEventUrl(event === 'QuickJump' ? $element.attr('data-url') : $element.parents('li').attr('data-url'));
        tracking.recordUserClick(event, type, 'PDP');

        let $anchor = $($element.attr('href'));
        let headerHeight = parseFloat($('.header').css('height'));
        let topPos = $anchor.offset().top - headerHeight;
        let stickyHeight = parseFloat($('.sticky-top-section').css('height'));
        topPos = $('.sticky-top-section').css('position') === 'fixed' ? topPos - stickyHeight - 5 : topPos - stickyHeight - 18;

        if ($element.attr('data-access-button')) {
            $($element.attr('data-access-button')).trigger('click');
        }
        $('html').animate({
            scrollTop: topPos
        }, 500, function () {
            if (utils.checkScreenSize('>=', 'tablet')) {
                if (event === 'QuickJump') {
                    $('.quick-jump-highlight').removeClass('quick-jump-highlight');
                    $element.addClass('quick-jump-highlight');
                } else if ($element.attr('data-highlight')) {
                    $('.quick-jump-highlight').removeClass('quick-jump-highlight');
                    $($element.attr('data-highlight')).addClass('quick-jump-highlight');
                }
            }
        });
        return false;
    }

    const checkEmail = function () {
        let emails = $('input.email-to:not(:hidden)');
        let filter = /[^\s@]+@[^\s@]+\.[^\s@]+/;
        let valid = true;

        emails.each(function() {
            valid = valid && filter.test($(this).val());
        });

        if (valid) {
            emails.parents('fieldset').removeClass('error');
            $('.j-email-err').hide();
        } else {
            emails.parents('fieldset').addClass('error');
            $('.j-email-err').show();
        }

        return valid;
    };

    function priceSeeMore() {
        const $this = $(this);
        $this.parents('ul').find('li').removeClass('hide');
        $this.parent().remove();
    }
}